<script>
  import { timeParse, timeFormat } from "d3-time-format";
  import { afterUpdate } from 'svelte';
  import { format } from "d3-format";
  const numFormat = format(",.0f");
  const dateParse = timeParse("%Y-%m-%d");
  const dateFormat = timeFormat("%b %d");

	export let pymChild = {};

	afterUpdate(() => {
			pymChild.sendHeight();
  });
  
  import ResultsPanel from "./graphics/results_panel.svelte";
  $: postcodeResult = null;

  let postcode = "";
  let resultsData = { selectedDistrict: "" };
  const styleNs = true;


  let errorMsg = "";

  function processPostcode(postcode) {
    let processedCode = postcode;
    //regex here:
    if(postcode.length > 7) {
      processedCode = processedCode.replace(" ", "");
    }
    if(postcode.length === 6) {
      processedCode = processedCode.slice(0, 3) + " " + processedCode.slice(3);
    }
    if(postcode.length === 5) {
      processedCode = processedCode.slice(0, 2) + "  " + processedCode.slice(2);
    }
    return processedCode.toUpperCase();
  }

  function handleEnter() {
    if (event.key === 'Enter') {
      submitPostcode();
    }
  }

  function submitPostcode() {
    //TODO: sanitise input + format correctly
    if(postcode !== "" && postcode.length > 4) {
      errorMsg = "Loading...";
      postcodeResult = null;
      fetch("https://9ornsrwb3m.execute-api.us-east-2.amazonaws.com/postcode-search", {
          method: 'POST',
          body: JSON.stringify({"postcode": processPostcode(postcode)})
        })
        .then(response => response.json())
        .then(json => {
          if(json.error || json.codes.country === "W92000004") {
            errorMsg = "Please enter a valid postcode in England.";
          }
          else {
            postcodeResult = json;
            errorMsg = "";
          }
        })
    }
    else if(postcode.length > 1) {
      errorMsg = "Please enter a full postcode.";
      postcodeResult = null;
    }
    else {
      errorMsg = "Please enter a valid postcode in England.";
      postcodeResult = null;
    }
  }
</script>

<style>
  @font-face {
    font-family: "Unit OT";
    src: url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitot-webfont.eot?#iefix") format("embedded-opentype"), url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitot-webfont.woff") format("woff"), url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitot-webfont.ttf") format("truetype"), url("/sites/all/themes/creative-responsive-theme/fonts/unitot-webfont.svg#unitotregular") format("svg");
    font-style: normal;
    font-weight: normal;
  }

  @font-face {
    font-family: "Unit Slab";
    src: url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitslabpro-bold-webfont.eot?#iefix") format("embedded-opentype"), url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitslabpro-bold-webfont.woff") format("woff"), url("https://www.citymetric.com/sites/all/themes/creative-responsive-theme/fonts/unitslabpro-bold-webfont.ttf") format("truetype"), url("/sites/all/themes/creative-responsive-theme/fonts/unitslabpro-bold-webfont.svg#unit_slab_probold") format("svg");
    font-style: normal;
    font-weight: normal;
  }

  .report-container {
    min-width: 280px;
    max-width: 900px;
    width: 95%;
    min-height: 100%;
    margin: 0 auto;
    padding: 0 4px;
    font-family: "Unit OT", sans-serif;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }

  :global(.chart-container) {
    width: 100%;
    height: 200px;
    padding: 8px;
  }

  :global(.source-text) {
    color: #607a8a;
    margin: 8px 0;
    font-size: 0.75em;
	}
	
	:global(button) {
		margin: 4px;
	}

	.clear {
		clear: both;
	}

  :global(h2),
  :global(h3),
  :global(h4),
  :global(h5) {
		margin: 0;
    padding: 0;
    font-family: "Unit Slab", serif;
  }

  :global(h2),
  :global(h4) {
    margin-top: 1em;
  }
  
  a {
    color: #0054c1;
  }

  hr {
    margin-top: 60px;
  }

</style>

<!-- <link
  href="https://fonts.googleapis.com/css?family=Merriweather:400,700&display=swap"
  rel="stylesheet" /> -->
<link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap" rel="stylesheet"> 
<div class="report-container" class:styleNs>
  <div class="header">
    <h2 id="page-nav">Green space in your area</h2>
    <label for="postcode-search">Enter your postcode:</label>
    <input bind:value={postcode} id="postcode-search" on:keypress={() => handleEnter()} />
    <button on:click={() => submitPostcode()}>Submit</button>
    <p>{errorMsg}</p>
    {#if postcodeResult && !postcodeResult.error}
    <ResultsPanel codes={postcodeResult.codes} data={postcodeResult.data} />
    {/if}
  </div>
</div>
